import { ListItemProps } from '@silverfort/sf-components';

export const LAST_CHANGES_FILTER_VALUES = {
    LAST_24_HOURS: '1',
    LAST_7_DAYS: '7',
    LAST_30_DAYS: '30'
};

export const LAST_CHANGES_FILTER_LABELS = {
    [LAST_CHANGES_FILTER_VALUES.LAST_24_HOURS]: 'Last 24 hours',
    [LAST_CHANGES_FILTER_VALUES.LAST_7_DAYS]: 'Last 7 days',
    [LAST_CHANGES_FILTER_VALUES.LAST_30_DAYS]: 'Last 30 days'
};

export const DEFAULT_LAST_CHANGES_FILTER = LAST_CHANGES_FILTER_VALUES.LAST_24_HOURS;

export const LAST_CHANGES_FILTER_DROPDOWN_ITEMS = Object.entries(LAST_CHANGES_FILTER_LABELS).map<ListItemProps<string>>(
    ([value, title]) => ({
        title,
        value
    })
);
